export const CODE = {
    401:"ชื่อบัญชี หรือ รหัสผ่านไม่ถูกต้อง",
    403:"ยังไม่ได้ยืนยันบัญชีผู้ใช้",
    409:'ข้อมูลซ้ำซ้อน',
    500:"พบข้อผิดพลาด"
}